/**
 * ImageWithFallback - Simple image component with "Image not found" fallback
 * Use this for thumbnails and smaller images that don't need the blur-up effect
 * For larger images (hero, product cards), use BlurImage instead
 */
import { useState } from 'react';

const ImageWithFallback = ({ 
  src, 
  alt = '', 
  className = '', 
  containerClassName = '',
  fallbackText = 'Image not found',
  ...props 
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError || !src) {
    return (
      <div className={`flex items-center justify-center bg-site-bg-alt ${containerClassName}`}>
        <span className="text-site-text-muted text-[9px] font-mono text-center px-1">
          {fallbackText}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
      {...props}
    />
  );
};

export default ImageWithFallback;
